import { render, staticRenderFns } from "./Denied.vue?vue&type=template&id=3d1d0acd&scoped=true&"
import script from "./Denied.vue?vue&type=script&lang=js&"
export * from "./Denied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1d0acd",
  null
  
)

export default component.exports